import BeschreibungDTO from "./BeschreibungDTO";

export default class EnumDTO {
  constructor(json) {
    if (json) {
      this.json = json;
      this.code = json.code
      this.beschreibung = new BeschreibungDTO(json.description)
    } else {
      this.json = {}
    }
  }

  get toItem() {
    return ({value: this.code, name: this.beschreibung.text})
  }

  get text() {
    return this.beschreibung.text
  }
}
